import axios from "axios";
import API_CONFIG from "../../Configurations/ApiDeclaration";

export function GetStockDashboardData(param, token) {
    const URL = API_CONFIG.GET_STOCK_DASHBOARD_DATA + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}
export function UploadBrokenSizeFile(date, token) {
    const URL = API_CONFIG.UPLOAD_BROKEN_SIZE_FILE;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.post(URL, date, headers);
}
export function DownlaodStockReport(param, token) {
    const URL = API_CONFIG.DOWNLOAD_DASHBOARD_REPORT + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}
export function GetReplenishmentFile(param, token) {
    const URL = API_CONFIG.REPLENISHMENT_FILE + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}
export function DownlaodStockBrokenSizeReport(param, token) {
    const URL = API_CONFIG.DOWNLOAD_BROKEN_SIZE_REPORT + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}
export function getStockFilterValue(param, token) {
    const URL = API_CONFIG.GET_FILTER_DATA_FOR_STOCK + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}
export function GetStockDashboardCardsData(param, token) {
    const URL = API_CONFIG.GET_STOCK_DASHBOARD_CARDS_DATA + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}